module.exports = __webpack_public_path__ + "static/media/avataaars.587ec2a6.png";